import { Injectable, inject } from '@angular/core';
import { ActionsSubject } from '@ngrx/store';
import { Observable, Subject, filter } from 'rxjs';

import { resetStudy, setStudy } from '../../app/state/actions';

export interface TableFilterState {
  filterText: string;
  failuresOnlyChecked: boolean;
  columnExcludedValues: Map<string, Set<string>>;
}

/**
 * Keeps shared-table filter selections in memory so they survive the table being destroyed
 * when the user switches tabs. State is keyed by the table's `filterStateKey`, and is dropped
 * whenever a study is loaded or a New Study is started.
 */
@Injectable({ providedIn: 'root' })
export class TableFilterStateService {
  private readonly states = new Map<string, TableFilterState>();
  private readonly resetSubject = new Subject<void>();

  /** Emits when all filters should be cleared, for tables that are still on screen. */
  readonly reset$: Observable<void> = this.resetSubject.asObservable();

  constructor() {
    inject(ActionsSubject).pipe(
      filter(action => action.type === setStudy.type || action.type === resetStudy.type)
    ).subscribe(() => this.clearAll());
  }

  get(key: string): TableFilterState | undefined {
    return this.states.get(key);
  }

  save(key: string, state: TableFilterState): void {
    this.states.set(key, state);
  }

  clear(key: string): void {
    this.states.delete(key);
  }

  clearAll(): void {
    this.states.clear();
    this.resetSubject.next();
  }
}
